import React from "react";
import Moment from "react-moment";
import moment from "moment";
import { DataFormats } from "utils/constants";

const FORMAT_RULES = [
  { test: /^\d{1,2}-\d{1,2}-\d{4}$/, format: ["DD-MM-YYYY", "D-M-YYYY", "DD-M-YYYY", "D-MM-YYYY"] },
  { test: /^\d{1,2}\/\d{1,2}\/\d{4}$/, format: ["DD/MM/YYYY", "D/M/YYYY", "DD/M/YYYY", "D/MM/YYYY"] },
  { test: /^\d{4}-\d{2}-\d{2}T/, format: moment.ISO_8601 },
  { test: /^\d{4}-\d{2}-\d{2}-\d{2}-\d{2}-\d{2}-\d{3}$/, format: "YYYY-MM-DD-HH-mm-ss-SSS" },
  { test: /^\d{4}-\d{2}-\d{2}-\d{2}-\d{2}-\d{2}$/, format: "YYYY-MM-DD-HH-mm-ss" },
  { test: /^\d{4}-\d{2}-\d{2}$/, format: "YYYY-MM-DD" },
];

// Date.prototype.toString(), e.g. "Fri Oct 16 2026 10:00:00 GMT+1000 (Australian Eastern Standard Time)"
const JS_DATE_STRING = /^[A-Z][a-z]{2} [A-Z][a-z]{2} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT[+-]\d{4}/;

const detectFormat = (str) => FORMAT_RULES.find((r) => r.test.test(str.trim()))?.format;

const isDateObject = (value) => (value instanceof Date || moment.isMoment(value)) && moment(value).isValid();

export const isDateString = (value) =>
  isDateObject(value) || (typeof value === "string" && (!!detectFormat(value) || JS_DATE_STRING.test(value)));

const DateDisplay = ({
  value,
  format = DataFormats.DATE_FORMAT_SHORT,
}) => {
  if (value == null || value === "") return null;

  if (isDateObject(value)) return <Moment date={value} format={format} trim />;
  if (typeof value === "string" && JS_DATE_STRING.test(value) && !isNaN(new Date(value))) {
    return <Moment date={new Date(value)} format={format} trim />;
  }

  const strValue = String(value).trim();
  const parseFormat = detectFormat(strValue);

  if (!parseFormat) return <>{strValue}</>;

  const parsed = moment(strValue, parseFormat, true);
  if (!parsed.isValid()) return <>{strValue}</>;

  return <Moment date={strValue} parse={parseFormat} format={format} trim />;
};

export default DateDisplay;